export const GLOBAL_HEADER_ID = "root";
